export const LegalTemplate = ({ embed, children }) => {
  if (embed) {
    return <section className="legal-main" dangerouslySetInnerHTML={{ __html: children }} />;
  }

  return (
    <section className="legal-background">
      <section className="section-layout">
        <section
          className="legal-main legal-main_paper"
          dangerouslySetInnerHTML={{ __html: children }}
        />
      </section>
    </section>
  );
};
